module.exports = __webpack_public_path__ + "static/media/c7bannerModul1_small.0ccd6000.jpg";